// // Complete tabs implementation for AdminDashboard
// import React, { useState, useEffect } from 'react';
// import { Button } from '../../components/ui/button';
// import { Input } from '../../components/ui/input';
// import { Textarea } from '../../components/ui/textarea';
// import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
// import { Plus, Edit, Trash2 } from 'lucide-react';
// import {
//   getStreamingContent,
//   createStreamingContent,
//   updateStreamingContent,
//   deleteStreamingContent,
//   getHero,
//   createOrUpdateHero,
//   uploadImage,
//   uploadVideo,
// } from '../../api';

// // Streaming Content Tab
// export const StreamingTab = ({ toast }) => {
//   const [content, setContent] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showForm, setShowForm] = useState(false);
//   const [editingContent, setEditingContent] = useState(null);
//   const [uploading, setUploading] = useState(false);
//   const [formData, setFormData] = useState({
//     title: '',
//     subtitle: '',
//     image: '',
//     video: '',
//     description: '',
//     link: '',
//     order: 0,
//   });

//   useEffect(() => {
//     fetchContent();
//   }, []);

//   const fetchContent = async () => {
//     try {
//       const data = await getStreamingContent();
//       setContent(data);
//     } catch (error) {
//       toast({
//         title: 'Error',
//         description: 'Gagal mengambil streaming content',
//         variant: 'destructive',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setUploading(true);
//     try {
//       const result = await uploadImage(file);
//       setFormData({ ...formData, image: result.url });
//       toast({
//         title: 'Berhasil',
//         description: 'Gambar berhasil diupload',
//       });
//     } catch (error) {
//       toast({
//         title: 'Error',
//         description: error.response?.data?.detail || 'Gagal upload gambar',
//         variant: 'destructive',
//       });
//     } finally {
//       setUploading(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (editingContent) {
//         await updateStreamingContent(editingContent.id, formData);
//         toast({
//           title: 'Berhasil',
//           description: 'Content berhasil diupdate',
//         });
//       } else {
//         await createStreamingContent(formData);
//         toast({
//           title: 'Berhasil',
//           description: 'Content berhasil dibuat',
//         });
//       }
//       setShowForm(false);
//       setEditingContent(null);
//       setFormData({
//         title: '',
//         subtitle: '',
//         image: '',
//         video: '',
//         description: '',
//         link: '',
//         order: 0,
//       });
//       fetchContent();
//     } catch (error) {
//       toast({
//         title: 'Error',
//         description: 'Gagal menyimpan content',
//         variant: 'destructive',
//       });
//     }
//   };

//   const handleEdit = (item) => {
//     setEditingContent(item);
//     setFormData(item);
//     setShowForm(true);
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm('Yakin ingin menghapus content ini?')) return;

//     try {
//       await deleteStreamingContent(id);
//       toast({
//         title: 'Berhasil',
//         description: 'Content berhasil dihapus',
//       });
//       fetchContent();
//     } catch (error) {
//       toast({
//         title: 'Error',
//         description: 'Gagal menghapus content',
//         variant: 'destructive',
//       });
//     }
//   };

//   if (loading) return <div>Loading...</div>;

//   if (showForm) {
//     return (
//       <div>
//         <div className="flex items-center justify-between mb-6">
//           <h2 className="text-3xl font-bold">
//             {editingContent ? 'Edit Streaming Content' : 'Tambah Streaming Content'}
//           </h2>
//           <Button
//             onClick={() => {
//               setShowForm(false);
//               setEditingContent(null);
//             }}
//             variant="outline"
//           >
//             Batal
//           </Button>
//         </div>

//         <Card>
//           <CardContent className="pt-6">
//             <form onSubmit={handleSubmit} className="space-y-4">
//               <div>
//                 <label className="block text-sm font-medium mb-2">Judul</label>
//                 <Input
//                   value={formData.title}
//                   onChange={(e) => setFormData({ ...formData, title: e.target.value })}
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-2">Subtitle (Optional)</label>
//                 <Input
//                   value={formData.subtitle}
//                   onChange={(e) => setFormData({ ...formData, subtitle: e.target.value })}
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-2">Deskripsi</label>
//                 <Textarea
//                   value={formData.description}
//                   onChange={(e) => setFormData({ ...formData, description: e.target.value })}
//                   rows={3}
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-2">Link</label>
//                 <Input
//                   value={formData.link}
//                   onChange={(e) => setFormData({ ...formData, link: e.target.value })}
//                   placeholder="https://..."
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-2">Order</label>
//                 <Input
//                   type="number"
//                   value={formData.order}
//                   onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) })}
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-2">Upload Gambar</label>
//                 <Input
//                   type="file"
//                   accept="image/*"
//                   onChange={handleImageUpload}
//                   disabled={uploading}
//                 />
//                 {formData.image && (
//                   <div className="mt-2">
//                     <img src={formData.image} alt="Preview" className="w-32 h-32 object-cover rounded" />
//                   </div>
//                 )}
//               </div>

//               <Button type="submit" className="w-full bg-orange-500 hover:bg-orange-600">
//                 {editingContent ? 'Update Content' : 'Tambah Content'}
//               </Button>
//             </form>
//           </CardContent>
//         </Card>
//       </div>
//     );
//   }

//   return (
//     <div>
//       <div className="flex items-center justify-between mb-6">
//         <h2 className="text-3xl font-bold">Streaming Content</h2>
//         <Button
//           onClick={() => setShowForm(true)}
//           className="bg-orange-500 hover:bg-orange-600"
//         >
//           <Plus className="mr-2" size={20} />
//           Tambah Content
//         </Button>
//       </div>

//       <div className="grid md:grid-cols-3 gap-6">
//         {content.map((item) => (
//           <Card key={item.id}>
//             <CardHeader>
//               <div className="aspect-video overflow-hidden rounded-lg mb-2">
//                 <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
//               </div>
//               <CardTitle className="text-lg">{item.title}</CardTitle>
//               {item.subtitle && <CardDescription>{item.subtitle}</CardDescription>}
//             </CardHeader>
//             <CardContent>
//               <div className="flex gap-2">
//                 <Button
//                   onClick={() => handleEdit(item)}
//                   variant="outline"
//                   size="sm"
//                   className="flex-1"
//                 >
//                   <Edit size={16} className="mr-1" />
//                   Edit
//                 </Button>
//                 <Button
//                   onClick={() => handleDelete(item.id)}
//                   variant="destructive"
//                   size="sm"
//                   className="flex-1"
//                 >
//                   <Trash2 size={16} className="mr-1" />
//                   Hapus
//                 </Button>
//               </div>
//             </CardContent>
//           </Card>
//         ))}
//       </div>

//       {content.length === 0 && (
//         <Card>
//           <CardContent className="py-12 text-center">
//             <p className="text-gray-500">Belum ada streaming content</p>
//           </CardContent>
//         </Card>
//       )}
//     </div>
//   );
// };

// // Hero Section Tab
// export const HeroTab = ({ toast }) => {
//   const [hero, setHero] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [uploading, setUploading] = useState(false);
//   const [formData, setFormData] = useState({
//     image: '',
//     video: '',
//   });

//   useEffect(() => {
//     fetchHero();
//   }, []);

//   const fetchHero = async () => {
//     try {
//       const data = await getHero();
//       setHero(data);
//       setFormData({
//         image: data.image || '',
//         video: data.video || '',
//       });
//     } catch (error) {
//       console.error('Error fetching hero:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setUploading(true);
//     try {
//       const result = await uploadImage(file);
//       setFormData({ ...formData, image: result.url });
//       toast({
//         title: 'Berhasil',
//         description: 'Gambar berhasil diupload',
//       });
//     } catch (error) {
//       toast({
//         title: 'Error',
//         description: error.response?.data?.detail || 'Gagal upload gambar',
//         variant: 'destructive',
//       });
//     } finally {
//       setUploading(false);
//     }
//   };

//   const handleVideoUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setUploading(true);
//     try {
//       const result = await uploadVideo(file);
//       setFormData({ ...formData, video: result.url });
//       toast({
//         title: 'Berhasil',
//         description: 'Video berhasil diupload',
//       });
//     } catch (error) {
//       toast({
//         title: 'Error',
//         description: error.response?.data?.detail || 'Gagal upload video',
//         variant: 'destructive',
//       });
//     } finally {
//       setUploading(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       await createOrUpdateHero(formData);
//       toast({
//         title: 'Berhasil',
//         description: 'Hero section berhasil diupdate',
//       });
//       fetchHero();
//     } catch (error) {
//       toast({
//         title: 'Error',
//         description: 'Gagal update hero section',
//         variant: 'destructive',
//       });
//     }
//   };

//   if (loading) return <div>Loading...</div>;

//   return (
//     <div>
//       <h2 className="text-3xl font-bold mb-6">Hero Section</h2>

//       <Card>
//         <CardContent className="pt-6">
//           <form onSubmit={handleSubmit} className="space-y-6">
//             <div>
//               <label className="block text-sm font-medium mb-2">Hero Image</label>
//               <Input
//                 type="file"
//                 accept="image/*"
//                 onChange={handleImageUpload}
//                 disabled={uploading}
//               />
//               {formData.image && (
//                 <div className="mt-4">
//                   <img src={formData.image} alt="Hero Preview" className="w-full max-h-96 object-cover rounded-lg" />
//                 </div>
//               )}
//             </div>

//             <div>
//               <label className="block text-sm font-medium mb-2">Hero Video (Optional)</label>
//               <Input
//                 type="file"
//                 accept="video/*"
//                 onChange={handleVideoUpload}
//                 disabled={uploading}
//               />
//               {formData.video && (
//                 <div className="mt-4">
//                   <video src={formData.video} controls className="w-full max-h-96 rounded-lg" />
//                 </div>
//               )}
//             </div>

//             <Button type="submit" className="w-full bg-orange-500 hover:bg-orange-600" disabled={uploading}>
//               {uploading ? 'Uploading...' : 'Update Hero Section'}
//             </Button>
//           </form>
//         </CardContent>
//       </Card>
//     </div>
//   );
// };

// // Sections Tab (Placeholder for now, can be extended)
// export const SectionsTab = ({ toast }) => {
//   const [sections, setSections] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [editingSection, setEditingSection] = useState(null);
//   const [uploading, setUploading] = useState(false);
//   const [formData, setFormData] = useState({
//     title: '',
//     subtitle: '',
//     description: '',
//     image: '',
//     link: '',
//   });

//   useEffect(() => {
//     fetchSections();
//   }, []);

//   const fetchSections = async () => {
//     try {
//       const { getSections } = await import('../../api');
//       const data = await getSections();
//       setSections(data);
//     } catch (error) {
//       toast({
//         title: 'Error',
//         description: 'Gagal mengambil sections',
//         variant: 'destructive',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setUploading(true);
//     try {
//       const result = await uploadImage(file);
//       setFormData({ ...formData, image: result.url });
//       toast({
//         title: 'Berhasil',
//         description: 'Gambar berhasil diupload',
//       });
//     } catch (error) {
//       toast({
//         title: 'Error',
//         description: error.response?.data?.detail || 'Gagal upload gambar',
//         variant: 'destructive',
//       });
//     } finally {
//       setUploading(false);
//     }
//   };

//   const handleEdit = (section) => {
//     setEditingSection(section);
//     setFormData({
//       title: section.title,
//       subtitle: section.subtitle,
//       description: section.description,
//       image: section.image,
//       link: section.link,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const { updateSection } = await import('../../api');
//       await updateSection(editingSection.section_type, formData);
//       toast({
//         title: 'Berhasil',
//         description: 'Section berhasil diupdate',
//       });
//       setEditingSection(null);
//       fetchSections();
//     } catch (error) {
//       toast({
//         title: 'Error',
//         description: 'Gagal update section',
//         variant: 'destructive',
//       });
//     }
//   };

//   const getSectionColor = (type) => {
//     const colors = {
//       draftkings: 'from-green-500 to-green-600',
//       lol_network: 'from-red-600 to-red-700',
//       hartbeat: 'from-red-600 to-red-700',
//       hartbeat_ventures: 'from-gray-900 to-black',
//     };
//     return colors[type] || 'from-gray-500 to-gray-600';
//   };

//   if (loading) return <div>Loading...</div>;

//   if (editingSection) {
//     return (
//       <div>
//         <div className="flex items-center justify-between mb-6">
//           <h2 className="text-3xl font-bold">
//             Edit Section: {editingSection.title}
//           </h2>
//           <Button
//             onClick={() => setEditingSection(null)}
//             variant="outline"
//           >
//             Batal
//           </Button>
//         </div>

//         <Card>
//           <CardContent className="pt-6">
//             <form onSubmit={handleSubmit} className="space-y-4">
//               <div>
//                 <label className="block text-sm font-medium mb-2">Title</label>
//                 <Input
//                   value={formData.title}
//                   onChange={(e) => setFormData({ ...formData, title: e.target.value })}
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-2">Subtitle</label>
//                 <Input
//                   value={formData.subtitle}
//                   onChange={(e) => setFormData({ ...formData, subtitle: e.target.value })}
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-2">Description</label>
//                 <Textarea
//                   value={formData.description}
//                   onChange={(e) => setFormData({ ...formData, description: e.target.value })}
//                   rows={5}
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-2">Link</label>
//                 <Input
//                   value={formData.link}
//                   onChange={(e) => setFormData({ ...formData, link: e.target.value })}
//                   placeholder="https://..."
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-2">Upload Gambar</label>
//                 <Input
//                   type="file"
//                   accept="image/*"
//                   onChange={handleImageUpload}
//                   disabled={uploading}
//                 />
//                 {formData.image && (
//                   <div className="mt-2">
//                     <img src={formData.image} alt="Preview" className="w-full max-h-64 object-cover rounded" />
//                   </div>
//                 )}
//               </div>

//               <Button type="submit" className="w-full bg-orange-500 hover:bg-orange-600">
//                 Update Section
//               </Button>
//             </form>
//           </CardContent>
//         </Card>
//       </div>
//     );
//   }

//   return (
//     <div>
//       <h2 className="text-3xl font-bold mb-6">Sections Management</h2>
//       <p className="text-gray-600 mb-6">
//         Kelola konten untuk DraftKings, LOL Network, Hartbeat, dan Hartbeat Ventures sections
//       </p>

//       <div className="grid md:grid-cols-2 gap-6">
//         {sections.map((section) => (
//           <Card key={section.id} className="overflow-hidden">
//             <div className={`h-3 bg-gradient-to-r ${getSectionColor(section.section_type)}`}></div>
//             <CardHeader>
//               <CardTitle className="text-xl">{section.title}</CardTitle>
//               <CardDescription className="font-semibold">{section.subtitle}</CardDescription>
//             </CardHeader>
//             <CardContent>
//               <div className="mb-4">
//                 <img
//                   src={section.image}
//                   alt={section.title}
//                   className="w-full h-48 object-cover rounded-lg mb-3"
//                 />
//                 <p className="text-sm text-gray-600 line-clamp-3">{section.description}</p>
//               </div>
//               <Button
//                 onClick={() => handleEdit(section)}
//                 className="w-full bg-orange-500 hover:bg-orange-600"
//               >
//                 <Edit size={16} className="mr-2" />
//                 Edit Section
//               </Button>
//             </CardContent>
//           </Card>
//         ))}
//       </div>
//     </div>
//   );
// };


// Complete tabs implementation for AdminDashboard
import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Plus, Edit, Trash2 } from 'lucide-react';
import {
  getStreamingContent,
  createStreamingContent,
  updateStreamingContent,
  deleteStreamingContent,
  getHero,
  createOrUpdateHero,
  uploadImage,
  uploadVideo,
} from '@/api';

// Streaming Content Tab
export const StreamingTab = ({ toast }) => {
  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingContent, setEditingContent] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    subtitle: '',
    image: '',
    video: '',
    description: '',
    link: '',
    order: 0,
  });

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const data = await getStreamingContent();
      setContent(data);
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Gagal mengambil streaming content',
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      const result = await uploadImage(file);
      setFormData({ ...formData, image: result.url });
      toast({
        title: 'Berhasil',
        description: 'Gambar berhasil diupload',
      });
    } catch (error) {
      toast({
        title: 'Error',
        description: error.response?.data?.detail || 'Gagal upload gambar',
        variant: 'destructive',
      });
    } finally {
      setUploading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingContent) {
        await updateStreamingContent(editingContent.id, formData);
        toast({
          title: 'Berhasil',
          description: 'Content berhasil diupdate',
        });
      } else {
        await createStreamingContent(formData);
        toast({
          title: 'Berhasil',
          description: 'Content berhasil dibuat',
        });
      }
      setShowForm(false);
      setEditingContent(null);
      setFormData({
        title: '',
        subtitle: '',
        image: '',
        video: '',
        description: '',
        link: '',
        order: 0,
      });
      fetchContent();
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Gagal menyimpan content',
        variant: 'destructive',
      });
    }
  };

  const handleEdit = (item) => {
    setEditingContent(item);
    setFormData(item);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Yakin ingin menghapus content ini?')) return;

    try {
      await deleteStreamingContent(id);
      toast({
        title: 'Berhasil',
        description: 'Content berhasil dihapus',
      });
      fetchContent();
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Gagal menghapus content',
        variant: 'destructive',
      });
    }
  };

  if (loading) return <div>Loading...</div>;

  if (showForm) {
    return (
      <div>
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-3xl font-bold">
            {editingContent ? 'Edit Streaming Content' : 'Tambah Streaming Content'}
          </h2>
          <Button
            onClick={() => {
              setShowForm(false);
              setEditingContent(null);
            }}
            variant="outline"
          >
            Batal
          </Button>
        </div>

        <Card>
          <CardContent className="pt-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2">Judul</label>
                <Input
                  value={formData.title}
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Subtitle (Optional)</label>
                <Input
                  value={formData.subtitle}
                  onChange={(e) => setFormData({ ...formData, subtitle: e.target.value })}
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Deskripsi</label>
                <Textarea
                  value={formData.description}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                  rows={3}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Link</label>
                <Input
                  value={formData.link}
                  onChange={(e) => setFormData({ ...formData, link: e.target.value })}
                  placeholder="https://..."
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Order</label>
                <Input
                  type="number"
                  value={formData.order}
                  onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) })}
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Upload Gambar</label>
                <Input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  disabled={uploading}
                />
                {formData.image && (
                  <div className="mt-2">
                    <img src={formData.image} alt="Preview" className="w-32 h-32 object-cover rounded" />
                  </div>
                )}
              </div>

              <Button type="submit" className="w-full bg-orange-500 hover:bg-orange-600">
                {editingContent ? 'Update Content' : 'Tambah Content'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-3xl font-bold">Streaming Content</h2>
        <Button
          onClick={() => setShowForm(true)}
          className="bg-orange-500 hover:bg-orange-600"
        >
          <Plus className="mr-2" size={20} />
          Tambah Content
        </Button>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {content.map((item) => (
          <Card key={item.id}>
            <CardHeader>
              <div className="aspect-video overflow-hidden rounded-lg mb-2">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
              </div>
              <CardTitle className="text-lg">{item.title}</CardTitle>
              {item.subtitle && <CardDescription>{item.subtitle}</CardDescription>}
            </CardHeader>
            <CardContent>
              <div className="flex gap-2">
                <Button
                  onClick={() => handleEdit(item)}
                  variant="outline"
                  size="sm"
                  className="flex-1"
                >
                  <Edit size={16} className="mr-1" />
                  Edit
                </Button>
                <Button
                  onClick={() => handleDelete(item.id)}
                  variant="destructive"
                  size="sm"
                  className="flex-1"
                >
                  <Trash2 size={16} className="mr-1" />
                  Hapus
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {content.length === 0 && (
        <Card>
          <CardContent className="py-12 text-center">
            <p className="text-gray-500">Belum ada streaming content</p>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

// Hero Section Tab
export const HeroTab = ({ toast }) => {
  const [hero, setHero] = useState(null);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [formData, setFormData] = useState({
    image: '',
    video: '',
  });

  useEffect(() => {
    fetchHero();
  }, []);

  const fetchHero = async () => {
    try {
      const data = await getHero();
      setHero(data);
      setFormData({
        image: data.image || '',
        video: data.video || '',
      });
    } catch (error) {
      console.error('Error fetching hero:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      const result = await uploadImage(file);
      setFormData({ ...formData, image: result.url });
      toast({
        title: 'Berhasil',
        description: 'Gambar berhasil diupload',
      });
    } catch (error) {
      toast({
        title: 'Error',
        description: error.response?.data?.detail || 'Gagal upload gambar',
        variant: 'destructive',
      });
    } finally {
      setUploading(false);
    }
  };

  const handleVideoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      const result = await uploadVideo(file);
      setFormData({ ...formData, video: result.url });
      toast({
        title: 'Berhasil',
        description: 'Video berhasil diupload',
      });
    } catch (error) {
      toast({
        title: 'Error',
        description: error.response?.data?.detail || 'Gagal upload video',
        variant: 'destructive',
      });
    } finally {
      setUploading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createOrUpdateHero(formData);
      toast({
        title: 'Berhasil',
        description: 'Hero section berhasil diupdate',
      });
      fetchHero();
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Gagal update hero section',
        variant: 'destructive',
      });
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <h2 className="text-3xl font-bold mb-6">Hero Section</h2>

      <Card>
        <CardContent className="pt-6">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium mb-2">Hero Image</label>
              <Input
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                disabled={uploading}
              />
              {formData.image && (
                <div className="mt-4">
                  <img src={formData.image} alt="Hero Preview" className="w-full max-h-96 object-cover rounded-lg" />
                </div>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Hero Video (Optional)</label>
              <Input
                type="file"
                accept="video/*"
                onChange={handleVideoUpload}
                disabled={uploading}
              />
              {formData.video && (
                <div className="mt-4">
                  <video src={formData.video} controls className="w-full max-h-96 rounded-lg" />
                </div>
              )}
            </div>

            <Button type="submit" className="w-full bg-orange-500 hover:bg-orange-600" disabled={uploading}>
              {uploading ? 'Uploading...' : 'Update Hero Section'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

// Sections Tab
export const SectionsTab = ({ toast }) => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingSection, setEditingSection] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    subtitle: '',
    description: '',
    image: '',
    link: '',
  });

  useEffect(() => {
    fetchSections();
  }, []);

  const fetchSections = async () => {
    try {
      const { getSections } = await import('@/api');
      const data = await getSections();
      setSections(data);
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Gagal mengambil sections',
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      const result = await uploadImage(file);
      setFormData({ ...formData, image: result.url });
      toast({
        title: 'Berhasil',
        description: 'Gambar berhasil diupload',
      });
    } catch (error) {
      toast({
        title: 'Error',
        description: error.response?.data?.detail || 'Gagal upload gambar',
        variant: 'destructive',
      });
    } finally {
      setUploading(false);
    }
  };

  const handleEdit = (section) => {
    setEditingSection(section);
    setFormData({
      title: section.title,
      subtitle: section.subtitle,
      description: section.description,
      image: section.image,
      link: section.link,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { updateSection } = await import('@/api');
      await updateSection(editingSection.section_type, formData);
      toast({
        title: 'Berhasil',
        description: 'Section berhasil diupdate',
      });
      setEditingSection(null);
      fetchSections();
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Gagal update section',
        variant: 'destructive',
      });
    }
  };

  const getSectionColor = (type) => {
    const colors = {
      draftkings: 'from-green-500 to-green-600',
      lol_network: 'from-red-600 to-red-700',
      hartbeat: 'from-red-600 to-red-700',
      hartbeat_ventures: 'from-gray-900 to-black',
      tour_banner: 'from-orange-500 to-orange-600', // Added this line
    };
    return colors[type] || 'from-gray-500 to-gray-600';
  };

  if (loading) return <div>Loading...</div>;

  if (editingSection) {
    return (
      <div>
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-3xl font-bold">
            Edit Section: {editingSection.title}
          </h2>
          <Button
            onClick={() => setEditingSection(null)}
            variant="outline"
          >
            Batal
          </Button>
        </div>

        <Card>
          <CardContent className="pt-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2">Title</label>
                <Input
                  value={formData.title}
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Subtitle</label>
                <Input
                  value={formData.subtitle}
                  onChange={(e) => setFormData({ ...formData, subtitle: e.target.value })}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Description</label>
                <Textarea
                  value={formData.description}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                  rows={5}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Link</label>
                <Input
                  value={formData.link}
                  onChange={(e) => setFormData({ ...formData, link: e.target.value })}
                  placeholder="https://..."
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Upload Gambar</label>
                <Input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  disabled={uploading}
                />
                {formData.image && (
                  <div className="mt-2">
                    <img src={formData.image} alt="Preview" className="w-full max-h-64 object-cover rounded" />
                  </div>
                )}
              </div>

              <Button type="submit" className="w-full bg-orange-500 hover:bg-orange-600">
                Update Section
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-3xl font-bold mb-6">Sections Management</h2>
      <p className="text-gray-600 mb-6">
        Kelola konten untuk Tour Banner, DraftKings, LOL Network, Hartbeat, dan Hartbeat Ventures
      </p>

      <div className="grid md:grid-cols-2 gap-6">
        {sections.map((section) => (
          <Card key={section.id} className="overflow-hidden">
            <div className={`h-3 bg-gradient-to-r ${getSectionColor(section.section_type)}`}></div>
            <CardHeader>
              <CardTitle className="text-xl">{section.title}</CardTitle>
              <CardDescription className="font-semibold">{section.subtitle}</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="mb-4">
                <img
                  src={section.image}
                  alt={section.title}
                  className="w-full h-48 object-cover rounded-lg mb-3"
                />
                <p className="text-sm text-gray-600 line-clamp-3">{section.description}</p>
              </div>
              <Button
                onClick={() => handleEdit(section)}
                className="w-full bg-orange-500 hover:bg-orange-600"
              >
                <Edit size={16} className="mr-2" />
                Edit Section
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};